/**
 * Mobile bottom navigation — opens right-panel dialogs + scroll-aware solid background.
 */

const MOBILE_MQ = window.matchMedia('(max-width: 1029px)');
const NAV_ID = 'ea-mobile-bottom-nav';

function isMobile() {
  return MOBILE_MQ.matches;
}

function getNav() {
  return document.getElementById(NAV_ID);
}

function setSolid(nav, solid) {
  nav?.classList.toggle('ea-mobile-bottom-nav--solid', solid);
  nav?.classList.toggle('ea-mobile-bottom-nav--transparent', !solid);
}

function togglePanel(action) {
  window.eaRightPanel?.toggle(action);
}

function wireActions(nav) {
  nav.addEventListener('click', (event) => {
    const item = event.target.closest('[data-ea-bottom-nav]');
    if (!item) return;

    event.preventDefault();
    togglePanel(item.dataset.eaBottomNav);
  });
}

let scrollRaf = null;
let scrollHandler = null;
let panelWasOpen = false;

function getScrollY() {
  return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function isAtHeroTop() {
  return getScrollY() <= 0;
}

function updateNavBackground(nav) {
  if (document.body.classList.contains('ea-mobile-panel-open')) {
    setSolid(nav, true);
    return;
  }

  if (nav.dataset.template !== 'index') {
    setSolid(nav, true);
    return;
  }

  // Transparent only at absolute top of homepage; any scroll → solid white bar
  setSolid(nav, !isAtHeroTop());
}

function attachHeroScrollListener(nav) {
  if (scrollHandler) {
    window.removeEventListener('scroll', scrollHandler);
    window.removeEventListener('resize', scrollHandler);
    scrollHandler = null;
  }

  if (nav.dataset.template !== 'index') {
    setSolid(nav, true);
    return;
  }

  const onScroll = () => {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(() => {
      scrollRaf = null;
      updateNavBackground(nav);
    });
  };

  scrollHandler = onScroll;
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  updateNavBackground(nav);
}

function watchPanelOpen(nav) {
  const observer = new MutationObserver(() => {
    const panelOpen = document.body.classList.contains('ea-mobile-panel-open');
    const panelJustClosed = panelWasOpen && !panelOpen;
    panelWasOpen = panelOpen;

    if (panelJustClosed) {
      nav.classList.add('ea-mobile-bottom-nav--bg-snap');
    }

    updateNavBackground(nav);

    if (panelJustClosed) {
      requestAnimationFrame(() => {
        nav.classList.remove('ea-mobile-bottom-nav--bg-snap');
      });
    }
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
}

function init() {
  const nav = getNav();
  if (!nav) return;

  wireActions(nav);
  panelWasOpen = document.body.classList.contains('ea-mobile-panel-open');
  watchPanelOpen(nav);

  if (isMobile()) {
    attachHeroScrollListener(nav);
  }

  MOBILE_MQ.addEventListener('change', (e) => {
    if (e.matches) {
      attachHeroScrollListener(nav);
    } else {
      if (scrollHandler) {
        window.removeEventListener('scroll', scrollHandler);
        window.removeEventListener('resize', scrollHandler);
        scrollHandler = null;
      }
      nav.classList.remove('ea-mobile-bottom-nav--solid');
      nav.classList.remove('ea-mobile-bottom-nav--transparent');
      nav.classList.remove('ea-mobile-bottom-nav--bg-snap');
    }
  });
}

document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', init)
  : init();
